import { useCallback, useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { getMediasInfos, getLMLRanking, LMLRankingApiResponse } from "../../../api/MediasRequests";
import { LoadingState } from "../../../navigation/LoadingState";
import { Interval } from "../../../navigation/tabs/Tabs";
import { Area } from "../../../navigation/tree/Area";
import {Trans} from "react-i18next"
import classes from "../../Statistics.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";

interface IProps {
    area: Area
    nodePath: string,
    startDateTimestamp: number,
    endDateTimestamp: number,
    interval: Interval,
    mediaspotSerials?: string[]

}

export const LMLRanking = (props: IProps) => {

    console.log(props.mediaspotSerials)
    
    const [mediasRanking, setLMLRanking] = useState<LMLRankingApiResponse|undefined>(undefined)
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.LOADING)
      
    const loadLMLRanking = async() => {
        setLoadingState(LoadingState.LOADING)
        const mediasRanking = await getLMLRanking(props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.area.mediaspot?.serial, props.mediaspotSerials)
        if(mediasRanking.data){
            setLMLRanking(mediasRanking.data)
            setLoadingState(LoadingState.LOADED)
        }else {
            setLoadingState(LoadingState.ERROR)
        }

    }

    // Each time props are updated, reload data
    useEffect(() => {
        loadLMLRanking()
    }, [props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.interval])

    
    return (
        <>
         {
            loadingState === LoadingState.LOADING ?
                <div className={classes.StatisticsLoaderContainer}>
                    <Loader type="Oval" color="#4185F4" height={50} width={50}/>
                </div> : null
        }
        {
            loadingState === LoadingState.ERROR ?
                <div className={classes.StatisticsErrorContainer}>
                    <label><Trans>AnErrorOccurredDuringLoading</Trans>...</label>
                    <br />
                    <button className={classes.RetryButton} onClick={() => loadLMLRanking()}><FontAwesomeIcon icon={faRedo} size={"sm"} color={"#404040"}/>&nbsp;&nbsp;<Trans>Reload</Trans></button>
                </div> : null
        }
            
        {
            loadingState === LoadingState.LOADED && mediasRanking ?

                mediasRanking.length === 0 ? <div className={classes.StatisticsNoDataContainer}>
                    <label><Trans>NoDataOnThisPeriod</Trans></label>
                </div> :

                <table>
                    <thead>
                        <tr>
                            <th>Edition</th>
                            <th>Nombre de lectures</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            mediasRanking.map(mediaRanking => {
                                const day = mediaRanking.media.substring(0, 2)
                                const month = mediaRanking.media.substring(2, 4)
                                
                                return (
                                    <tr>
                                        <td>Edition du {day}/{month}</td>
                                        <td>{mediaRanking.count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                : undefined
            }
        </>
    )
}